const manifestNamespace = "manifest";

export function getManifestVar(name, includeVarPrefix = true) {
  const varName = `--${manifestNamespace}-${name}`;
  if (includeVarPrefix) {
    return `var(${varName})`;
  }
  return varName;
}

export function convertRecordToCSSVariables<T extends Record<string, string>>(values: T) {
  return Object.keys(values).reduce((variableMap, key: keyof T) => {
    // eslint-disable-next-line no-param-reassign
    variableMap[key] = getManifestVar(key);
    return variableMap;
  }, {} as Record<keyof T, string>);
}

export function convertRecordToClassNames<T extends Record<string, string>>(values: T) {
  return Object.keys(values).reduce((variableMap, key: keyof T) => {
    // eslint-disable-next-line no-param-reassign
    variableMap[key] = key as string;
    return variableMap;
  }, {} as Record<keyof T, string>);
}

export function addCSSVariablesToHTML(values: Record<string, string>) {
  Object.keys(values).forEach((key) => {
    document.documentElement.style.setProperty(getManifestVar(key, false), values[key]);
  });
}

export function addCSSColorClassesToHTML(values: Record<string, string>) {
  const cssClasses: string[] = [];
  Object.keys(values).forEach((key) => {
    cssClasses.push(`.${key} { color: ${getManifestVar(key, true)}; }`);
  });
  document.querySelector(".manifest-classes")?.remove();
  const style = document.createElement("style");
  style.id = "manifest-classes";
  style.type = "text/css";
  style.innerHTML = cssClasses.join(" ");
  document.getElementsByTagName("head")[0].appendChild(style);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function updateCSSVariable<Values extends Record<string, string>>(values: Values) {
  return function update(from: keyof Values, to: string | number) {
    document.documentElement.style.setProperty(getManifestVar(from, false), to.toString());
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function revertCSSVariable<Values extends Record<string, string>>(values: Values) {
  return function revert(from: keyof Values) {
    document.documentElement.style.setProperty(getManifestVar(from, false), values[from]);
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function updateCSSColorVariable<Values extends Record<string, string>>(values: Values) {
  return function update(from: keyof Values, to: keyof Values) {
    document.documentElement.style.setProperty(getManifestVar(from, false), getManifestVar(to));
  };
}
